export default __webpack_public_path__ + "static/media/13.7b6564a3.jpg";